<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Staff Reports</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li class="breadcrumb-item active">Staff Reports</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="row justify-content">
          <div class="col-sm-4" style="margin-top: -18px !important">
            <label class="boldText" style="margin-bottom: 0px !important"
              >Users</label
            >
            <div>
              <Multiselect
                v-model="selectedUsers"
                mode="tags"
                placeholder="Select Users"
                :searchable="true"
                :createTag="true"
                :options="usersList"
              />
            </div>
          </div>

          <!-- <div class="col-sm-4" style="margin-top: -18px !important">
            <label class="boldText" style="margin-bottom: 0px !important"
              >Practices</label
            >
            <div>
              <Multiselect
                v-model="selectedPractice"
                placeholder="Select Users"
                :searchable="true"
                :createTag="true"
                :options="practices"
              />
            </div>
          </div> -->

          <div class="col-sm-4">
            <input
              style="margin-bottom: 6px; margin-left: 51px"
              type="text"
              name="daterangePR"
              :value="initDatePR"
              @change="datePickerPR"
              @focus="datePickerPR"
            />
            <div class="input-group-append">
              <span
                class="input-group-text"
                style="
                  position: absolute;
                  margin-top: -34px;
                  margin-left: 230px;
                "
              >
                <span class="ti-calendar"></span>
              </span>
            </div>
          </div>
        </div>
        <p></p>

        <div class="card">
          <!-- Nav tabs -->
          <ul class="nav nav-tabs customtab" role="tablist">
            <li class="nav-item" v-for="(stage, ndx01) in stages" :key="ndx01">
              <a
                :class="
                  activeStageId === stage.stageId
                    ? 'nav-link active'
                    : 'nav-link'
                "
                data-toggle="tab"
                href="#home2"
                role="tab"
                @click="stageTabClick(ndx01)"
                ><span class="hidden-sm-up"></span>
                <span class="hidden-xs-down">{{ stage.stageName }}</span></a
              >
            </li>
          </ul>
          <!-- Tab panes -->

          <div class="tab-content pb-3">
            <div class="tab-pane active" id="home2" role="tabpanel">
              <table
                class="
                  table
                  display
                  table-bordered
                  text-center
                  table-striped
                  no-wrap
                "
                id="example23"
              >
                <thead class="thead-dark">
                  <tr>
                    <th>Name</th>
                    <th>Count</th>
                    <th>Percent</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(sstage, ndx002) in singleStage" :key="ndx002">
                    <td>{{ sstage.operatorName }}</td>
                    <td>{{ sstage.visitCount }}</td>
                    <td>{{ sstage.percentage }}%</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="tab-pane p-20" id="profile2" role="tabpanel">2</div>
            <div class="tab-pane p-20" id="messages2" role="tabpanel">3</div>
          </div>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
  </div>
</template>

<script>
import localMixin from "./Mixins/StaffReport";
//import axios from "axios";
import moment from "moment";
import Multiselect from "@vueform/multiselect";
// import Swal from "sweetalert2";

export default {
  name: "StaffReport",
  mixins: [localMixin],
  components: {
    Multiselect,
  },

  data() {
    return {
      payments: [],
      users: [],
      practices: [],
      stages: [],
      visitSteps: [],

      singleStage: [
        {
          operatorName: "",
          visitCount: 0,
          percentage: 0,
        },
      ],

      activeStageId: 0,
      activeStageNdx: 0,

      usersList: ["A", "B", "C", "D"],
      selectedUsers: [],

      selectedPractice: "",

      startDatePR: "",
      endDatePR: "",
      initDatePR: "",
      dummyDate: moment(String(new Date())).format("YYYY-MM-DD"),
    };
  }, // data

  methods: {}, // methods

  computed: {}, // computed

  watch: {
    initDatePR: function () {
      this.fetchInitData();
    },

    selectedUsers: function () {
      this.fetchInitData();
    },

    selectedPractice: function () {
      this.fetchInitData();
    },

    users: function (val) {
      this.usersList = [];
      for (let i = 0; i < val.length; i++) {
        this.usersList.push(val[i].name);
      }
    },

    singleStage: function () {
      let kount = 0;
      for (let i = 0; i < this.singleStage.length; i++)
        kount += this.singleStage[i].visitCount;
      if (isNaN(kount)) kount = 1;

      this.singleStage = this.singleStage.sort(
        //this.dynamicSort("operatorName")
      );

      for (let i = 0; i < this.singleStage.length; i++) {
        try {
          let x = this.singleStage[i].visitCount / kount;
          let p = x * 100;
          if (isNaN(p)) p = 0;

          this.singleStage[i].percentage = p;
        } catch {
          this.singleStage[i].percentage = 0;
        }
      }
    },
  }, //watch

  mounted() {
    this.loadInit();
  }, // mounted
};
</script>

<style>
</style>